import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import type { ApiResultV2 } from '@malou-io/package-utils';

import type { InformationFormData } from ':shared/interfaces/information-form-data.interface';

import { environment } from ':environments/environment';

@Injectable({
    providedIn: 'root',
})
export class HubSpotHttpService {
    readonly API_BASE_URL = `${environment.APP_MALOU_API_URL}/api/maloupe/hubspot`;

    private readonly _http = inject(HttpClient);

    submitForm(formData: Partial<InformationFormData>): Observable<ApiResultV2> {
        return this._http.post(`${this.API_BASE_URL}/submit-information`, formData);
    }
}
